// extracted by mini-css-extract-plugin
export default {"search":"Search_search__Wncrn","wrapper":"Search_wrapper__jC8nN","searchButton":"Search_searchButton__8Jp1t"};